import { apiService } from './apiService'
import { requestEndpoints } from '../api/apiEndpoint'

import { CompanyRequest } from '@/common/types/request'

export const requestService = {
  

  async getRequestCompany(
    notificationId: string
  ): Promise<CompanyRequest | null> {
    try {
      const response = await apiService.get<CompanyRequest>(
        requestEndpoints.requestCompany(notificationId)
      )
      return response
    } catch (err: any) {
      console.error(err)
      return null
    }
  },
}
